import { Stack } from '@mui/material'
import { Toggle } from 'ComponentLibrary/src/atoms/Toggle/Toggle'
import { IconButton } from 'ComponentLibrary/src/piazza'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { PencilSimpleIcon } from '@phosphor-icons/react'
import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'

export type TaskHeaderProps = {
    title: string
    isDone: boolean
    toggleStatus: () => void
    onEdit: () => void
    copy?: Partial<TaskHeaderCopy>
}

export type TaskHeaderCopy = {
    editTitleAriaLabel: string
}

const DEFAULT_TASK_HEADER_COPY: TaskHeaderCopy = {
    editTitleAriaLabel: 'Titel bearbeiten',
}

export function TaskHeader({ title, isDone, toggleStatus, onEdit, copy }: TaskHeaderProps) {
    const resolvedCopy = { ...DEFAULT_TASK_HEADER_COPY, ...copy }
    return (
        <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center" marginRight={tokens.SizingSpacing100}>
            <Stack gap={tokens.SizingSpacing100} direction="row" alignItems="center" maxWidth="100%">
                <Toggle isOn={isDone} onToggle={toggleStatus} />
                <TextWithEllipsis
                    tooltipText={title}
                    typographyProps={{
                        variant: 'headline2',
                        lineClamp: 2,
                        color: isDone ? tokens.ColorTextSubtle : tokens.ColorTextBoldest,
                    }}
                >
                    {isDone ? <del>{title}</del> : title}
                </TextWithEllipsis>
            </Stack>
            <IconButton
                ariaLabel={resolvedCopy.editTitleAriaLabel}
                variant="tertiary"
                size="medium"
                icon={<PencilSimpleIcon color={tokens.ColorIconBoldest} />}
                onClick={onEdit}
            />
        </Stack>
    )
}
